export default "__VITE_ASSET__BknHZtK2__"